import { createContext, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';

const ctx = createContext();

export function NodeContextProvider({
  children,
  events,
  workflowTypeNodeMap,
  entity,
  value,
  selectedKeyPath,
  canvasRef,
  readonly,
}) {
  const ctxValue = useMemo(
    () => ({
      events,
      workflowTypeNodeMap,
      entity,
      value,
      selectedKeyPath,
      canvasRef,
      readonly,
    }),
    [events, workflowTypeNodeMap, entity, value, selectedKeyPath, canvasRef, readonly],
  );

  return <ctx.Provider value={ctxValue}>{children}</ctx.Provider>;
}

NodeContextProvider.propTypes = {
  children: PropTypes.node,
  events: PropTypes.shape({}),
  workflowTypeNodeMap: PropTypes.shape({}), // <token, detail>
  entity: PropTypes.shape({}),
  value: PropTypes.shape({}),
  selectedKeyPath: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  canvasRef: PropTypes.shape({}),
  readonly: PropTypes.bool,
};

export function useEvents() {
  return useContext(ctx)?.events ?? {};
}

export function useWorkflowTypeNodeMap() {
  return useContext(ctx)?.workflowTypeNodeMap;
}

export function useValue() {
  return useContext(ctx)?.value;
}

export function useSelectedKeyPath() {
  return useContext(ctx)?.selectedKeyPath;
}

export function useEntity() {
  return useContext(ctx)?.entity;
}

export function useCanvasRef() {
  return useContext(ctx)?.canvasRef;
}

export function useReadonly() {
  return useContext(ctx)?.readonly;
}
